import { Youtube, Instagram, Linkedin, Mail } from "lucide-react";
import TimezoneClock from "./TimezoneClock";

/**
 * Sidebar footer with social icons, contact email, and timezone clock.
 *
 * Matches the reference aesthetic — single-column list, soft icons,
 * compact metadata. Email + socials are placeholders; wire to real
 * accounts once they exist.
 */

const SOCIAL_LINKS = [
  { id: "youtube", icon: Youtube, label: "Youtube", href: "#", suffix: "—" },
  { id: "instagram", icon: Instagram, label: "Instagram", href: "#" },
  { id: "linkedin", icon: Linkedin, label: "LinkedIn", href: "#" },
];

const CONTACT_EMAIL = "hello@wedeshi.io";

export default function SidebarFooter() {
  return (
    <div className="space-y-1 text-sm">
      {SOCIAL_LINKS.map((s) => {
        const Icon = s.icon;
        return (
          <a
            key={s.id}
            href={s.href}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-2.5 py-1.5 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <Icon className="w-4 h-4 text-gray-500" strokeWidth={1.5} />
            <span>{s.label}</span>
          </a>
        );
      })}

      <a
        href={`mailto:${CONTACT_EMAIL}`}
        className="flex items-center gap-3 px-2.5 py-1.5 rounded-md text-gray-700 hover:bg-gray-100 transition-colors mt-3"
      >
        <Mail className="w-4 h-4 text-gray-500" strokeWidth={1.5} />
        <span>{CONTACT_EMAIL}</span>
      </a>

      <div className="px-2.5 pt-2 pb-1 flex items-center justify-center">
        <TimezoneClock />
      </div>
    </div>
  );
}
